<template>
  <div id="teacher-training-modules">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="teacher-training-modules-table" fluid>
      <b-row class="mt-4">
        <b-col class="md-6">
          <div class="table-wrap">
            <br />
            <b-col cols="6">
              <h4 class="subtitle">Teacher's Completed Training Modules</h4>
              <b-table
                v-cloak
                responsive
                :fields="trainingModuleFields"
                :items="teacherModules"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template slot="cell(trainer_name)" slot-scope="row">
                  <b-link
                    v-if="isAdmin || isSRC"
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditTrainer',
                      params: { id: row.item.trainer_uuid },
                    }"
                  >
                    {{ row.item.trainer_first_name }}
                    {{ row.item.trainer_last_name }}
                  </b-link>
                  <p v-if="!isAdmin || !isSRC">
                    {{ row.item.trainer_first_name }}
                    {{ row.item.trainer_last_name }}
                  </p>
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TeacherService from "../services/TeacherService";

export default {
  name: "TeacherTrainingModules",
  data() {
    return {
      teacherId: this.$route.params.id ? this.$route.params.id : null,
      trainingModuleFields: [
        { key: "trainer_name", label: "Trainer Name", sortable: true },
        { key: "course", label: "Course", sortable: true },
        { key: "module_date", label: "date", sortable: true },
      ],
      currentPage: 1,
      perPage: 16,
      totalRows: this.rows,
    };
  },
  methods: {
    ...mapActions({
      GET_TEACHER_MODULES: "teachers/GET_TEACHER_MODULES",
    }),
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    teacherModules: {
      get() {
        // add some stuff to clean this up
        return this.$store.state.teachers.modules;
      },
    },
  },
  created() {
    this.GET_TEACHER_MODULES();
  },
};
</script>

<style scoped>
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
